import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { TournamentService } from '../services/tournament/tournament.service';
import { TournamentCourse } from '../models/tournamentCourse';

@Injectable({ providedIn: 'root' })
export class TournamentCourseResolver implements Resolve<TournamentCourse> {
  constructor(private tournamentService: TournamentService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<TournamentCourse> {
    // Parent route defines tournamentId
    const tournamentId = route.parent?.params['tournamentId'];
    const courseId = route.params['courseId'];
    return this.tournamentService.getTournamentCourse(tournamentId, courseId);
  }
}
